export default __webpack_public_path__ + "static/r120-large-9db5594bed139c01f9fee17004fef882.png";